<div  class="overlay"></div>
<section id="hero" class="d-flex align-items-center"
    [ngStyle]="{'background-image': getHomeImage(themeSettingsData) !== 'none' ? 'url(' + getHomeImage(themeSettingsData) + ')' : 'none'}"
    class="imgClass">
    <div class="container-fluid mt-5" *ngIf="themeSettingsData.banner_type">
        <div class="row ">
            <div class="col-lg-6 pt-5 mt-5 order-sm-1 oder-md-1 order-lg-2 d-flex flex-column justify-content-center">
                <h2 tabindex="0" class="banner-primary-heading pt-5">
                    {{themeSettingsData.banner_heading}}
                </h2>
                <h3 tabindex="0" data-aos="fade-up " data-aos-delay="400" class="banner-content-color">
                    {{themeSettingsData.banner_content}}</h3>
                <p tabindex="0" data-aos="fade-up " class="banner_secondary_content mt-3" data-aos-delay="600">
                    {{themeSettingsData.banner_secondary_content}}</p>
                    <div data-aos="fade-up" data-aos-delay="800" class="mt-3" *ngIf="themeSettingsData.button_label">
                        <a tabindex="0" role="button" [attr.aria-label]="themeSettingsData.button_label" title="themeSettingsData.button_label"
                        class="btn-get-started scrollto button-text-color rvh-banner-btn">{{themeSettingsData.button_label}}</a>
                    </div>
            </div>
            <div class="col-lg-6 order-1 order-lg-2 hero-img" data-aos="fade-left" data-aos-delay="200">
                <div class="col upimg" *ngIf="themeSettingsData.banner_type==='Transparent'">
                    <img src="assets/images/graphics.webp" class="float-end pt-2 " alt="">
                </div>
                <div class="col-sm col-md img-padding" data-aos="fade-left" data-aos-delay="200">
                    <img class="float-start mg-fluid animated" *ngIf="themeSettingsData.banner_type==='Transparent'"
                        src="{{imageUrl}}{{themeSettingsData.banner_transparent_image}}"
                        [alt]="themeSettingsData.banner_trans_alt_text">
                </div>
                <div class="col-sm col-md downimg" *ngIf="themeSettingsData.banner_type==='Transparent'">
                    <img src="assets/images/rectangle_grid/Group 1672.png" class="img-fluid float-end" alt="">
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid" *ngIf="!themeSettingsData.banner_type">
        <div class="row">
            <div class="col-lg-12 order-1 order-lg-2 hero-img" data-aos="fade-left" data-aos-delay="200">
                <img class="float-start mg-fluid animated " style="width:100%;margin-top: 8%;"
                    *ngIf="themeSettingsData.banner_type==='Transparent'"
                    src="{{themeSettingsData.banner_transparent_image}}"
                    [alt]="themeSettingsData.banner_trans_alt_text">
                <div class="centered-text">
                    <h2 tabindex="0" class="banner-primary-heading">
                        {{themeSettingsData.banner_heading}}
                        {{themeSettingsData.journal_banner}}</h2>
                    <h3 tabindex="0" data-aos="fade-up" data-aos-delay="400"
                        class="banner-secondary-color">
                        {{themeSettingsData.banner_content}}</h3>
                    <p tabindex="0" data-aos="fade-up" data-aos-delay="600" class="banner-secondary-text-color mt-3">
                        {{themeSettingsData.banner_secondary_content}}</p>
                    <div data-aos="fade-up" data-aos-delay="800">
                        <a href="#about" role="button" [attr.arial-label]="themeSettingsData.button_label" 
                            class="btn-get-started scrollto button-text-color">{{themeSettingsData.button_label}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
<main id="main">
    <!-- ======= Search Article Section Starts======= -->
    <section id="about" class="about" aria-label="about">
        <div class="container">
            <div class="card article-search-card " data-aos="fade-up">
                <div class="card-body">
                    <div class="section-title" data-aos="fade-up">
                        <h2 class="primary">{{'journal_home.search_articles' | translate}}</h2>
                    </div>

                    <!--article-search component -->
                    <app-article-search (searchEmit)="searchEmitFunction($event)" [journalid]="journalid"
                        (searchClick)="showSearchedArticle($event)" (clearSearchClick)="clearSearch($event)"
                        [searchLoader]="searchLoader" [selectDiv]="selectDiv" (journalEmit)="journalEmit($event)"></app-article-search>
                    <!--article-search component -->

                    <!-- artcile-search-list component -->
                    <app-article-search-list [searchedArticles]="searchedArticles"
                        [tempSearchArticles]="tempSearchArticles" [journalid]="journalid"
                        [valueForSearch]="valueForSearch"
                        [show_search_list]="show_search_list"></app-article-search-list>
                    <!-- artcile-search-list component -->

                    <!-- check box -->
                    <app-article-filters [journalId]="journalid" (emitCheck)="checkBoxChange($event)"
                        [keywordFIlter]="false" [journal_id]="journalid" [subject_area_filter]="subject_area_filter">
                    </app-article-filters>
                    <!-- check box ends-->

                </div>
            </div>
        </div>
    </section>
      <!-- ======= Search Article Section End ======= -->
    <section id="about" class="about"
        *ngIf="themeSettingsData.journal_about !== null || themeSettingsData.journal_about !== '';">
        <div class="container-fluid">
            <div class="row ">
                <div class="section-title" data-aos="fade-up">
                    <h2 tabindex="0" class="primary-color">{{'app_header.about' | translate}}</h2>
                    <p tabindex="0" class="rvh-sub-heading">Find out why we're passionate about publishing.</p>
                </div>
                <div class="col-sm-4 col-md-4  d-flex justify-content-center align-items-center ">
                    <img tabindex="0" *ngIf="themeSettingsData.journal_logo"
                        class="img-fluid rounded rvh-home-pub-logo m-1 z-index"
                        src="{{imageUrl}}{{themeSettingsData.journal_logo}}" [alt]="themeSettingsData.logo_alt_text">
                    <img tabindex="0" *ngIf="!themeSettingsData.journal_logo"
                        class="img-fluid rounded rvh-home-pub-logo m-1 z-index" src="{{defaultPublisherLogo}}"
                        [alt]="'common.default_publisher_logo'|translate">
                </div>
                <div class="col-sm-8 col-md-8 pr-4 pl-4">
                    <p tabindex="0" [attr.aria-label]="themeSettingsData.journal_about"
                        class="text-color-black-home" data-aos="fade-up" data-aos-delay="150"
                        [innerHTML]="themeSettingsData.journal_about"></p>
                </div>
            </div>

            <div class="row" data-aos="fade-up" data-aos-delay="250">
                <div class="col-sm-12 text-align-right primary-color">
                    <span class="text-color-blue float-end underline" href="">{{'main_body.follow_as' |
                        translate}}</span>
                </div>
            </div>

            <div class="row pt-2 pb-3" data-aos="fade-up" data-aos-delay="300">
                <div class="col-sm-12 follow-us-icon">
                    <span *ngFor="let media of themeSettingsData.social_media_links">
                        <a class="pl-3" *ngIf="media.value"  role="link"
                            [attr.aria-label]="media.label" target="_blank" [href]="ensureHttps(media.value)">
                            <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                        </a>
                     
                    </span>

                </div>
            </div>
        </div>
    </section>
      <section id="journals" class="journals" *ngIf="journalData">
        <div class="container-fluid">
            <div class="section-title" data-aos="fade-up">
                <h2 tabindex="0" class="primary-color">{{'app_header.journals' | translate}}</h2>
                <p tabindex="0" class="rvh-sub-heading">{{'app_header.journal_sub_heading'|translate}}</p>
            </div>

            <img class=" img-fluid img-rect-left position-absolute ml-1" src="assets/images/Rectangle 501.webp" alt="">

            <div class="row">

                <div class="col-md-4" *ngFor="let eachJournal of journalData">
                    <div class="rvh-journal-card">
                        <img *ngIf="eachJournal.journal_cover_image" class="rvh-journal-cover-img" tabindex="0"
                            src="{{imageUrl+eachJournal.journal_cover_image}}"
                            [alt]="eachJournal.journal_cover_alt_text">
                        <img *ngIf="!eachJournal.journal_cover_image" class="rvh-journal-cover-img" tabindex="0"
                            src="{{defaultJournalCoverImage}}" [alt]="'site_home.default_journal_image'|translate">
                        <div class="rvh-journal-description-bk"></div>
                        <div class="rvh-journal-logo">
                            <img *ngIf="eachJournal.journal_logo" tabindex="0"
                                src="{{imageUrl+eachJournal.journal_logo}}" [alt]="eachJournal.journal_logo_alt_text">
                            <img *ngIf="!eachJournal.journal_logo" tabindex="0" src="{{defaultJournalLogo}}"
                                [alt]="'common.default_journal_logo'|translate">
                        </div>
                        <div class="rvh-journal-description" tabindex="0">
                            <div class="rvh-jnl-name" [attr.aria-label]="eachJournal.journal_display_name"
                                [innerHTML]="eachJournal.journal_display_name"></div>
                        </div>
                        <div class="rvh-journal-info pt-4">
                            <div>
                                <span>
                                    <a class="jounal-volume-link" [routerLink]="['/journal/',eachJournal.id,'volumes']"
                                        [attr.aria-label]="('site_home.latest_volume_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_volume'|translate}}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span>
                                    <a class="jounal-volume-link"
                                        [routerLink]="['/journal/',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue]"
                                        [attr.aria-label]="('site_home.latest_issue_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_issue'|translate}}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span>
                                    <a class="jounal-volume-link"
                                        [routerLink]="[ '/journal/',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue,eachJournal.latest_article]"
                                        [attr.aria-label]="('site_home.latest_article_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_article'|translate}}
                                    </a>
                                </span>
                            </div>
                        </div>
                        <div class="rvh-journal-socialmedia-icons">
                            <a *ngFor="let media of eachJournal.social_media_links" class="card-sm-icon "
                                [routerLink]="['{{media.value}}']" role="link" [attr.aria-label]="media.label">
                                <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                            </a>
                        </div>
                        <div class="rvh-journal-btn">
                            <a [routerLink]="[ '/journal/',eachJournal.id]"
                                [attr.aria-label]="'go to'+eachJournal.journal_display_name">{{'journal_home.go_to_journal'
                                |
                                translate}}</a>
                        </div>
                    </div>

                </div>
                <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end mt-4" data-aos="fade-right">
                    <a [routerLink]="['/journals']" tabindex="0" role="link" aria-label="View all journals" class="">
                        {{'book_home.view_all' | translate}}
                        <span class="badge rounded-pill p-1 bg-primary">
                            <fa-icon aria-hidden="true" icon="arrow-right"></fa-icon>
                        </span>
                    </a>
                </p>
                <div class="section-title" data-aos="fade-up"
                    *ngIf="journalConferenceData && journalConferenceData.length!==0">
                    <h2 tabindex="0" class="primary-color">{{'app_header.proceedings'| translate}}
                        ({{'proceedings.currentconference' | translate}}) </h2>
                    <p tabindex="0" class="rvh-sub-heading">{{'app_header.conference_sub_heading'|translate}}</p>
                </div>
                <div class="col-md-4" *ngFor="let eachJournal of journalConferenceData">
                    <div class="rvh-journal-card">
                        <img *ngIf="eachJournal.journal_cover_image" class="rvh-journal-cover-img" tabindex="0"
                            src="{{imageUrl+eachJournal.journal_cover_image}}"
                            [alt]="eachJournal.journal_cover_alt_text">
                        <img *ngIf="!eachJournal.journal_cover_image" class="rvh-journal-cover-img" tabindex="0"
                            src="{{defaultJournalCoverImage}}" [alt]="'site_home.default_journal_image'|translate">
                        <div class="rvh-journal-description-bk"></div>
                        <div class="rvh-journal-logo">
                            <img *ngIf="eachJournal.journal_logo" tabindex="0"
                                src="{{imageUrl+eachJournal.journal_logo}}" [alt]="eachJournal.journal_logo_alt_text">
                            <img *ngIf="!eachJournal.journal_logo" tabindex="0" src="{{defaultJournalLogo}}"
                                [alt]="'common.default_journal_logo'|translate">
                        </div>
                        <div class="rvh-journal-description" tabindex="0">
                            <div class="rvh-jnl-name" [attr.aria-label]="eachJournal.journal_display_name"
                                [innerHTML]="eachJournal.journal_display_name"></div>
                        </div>
                        <div class="rvh-journal-info pt-4">
                            <div>
                                <span>
                                    <a class="jounal-volume-link" [routerLink]="['/journal/',eachJournal.id,'volumes']"
                                        [attr.aria-label]="('site_home.latest_volume_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_volume'|translate}}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span>
                                    <a class="jounal-volume-link"
                                        [routerLink]="['/journal/',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue]"
                                        [attr.aria-label]="('site_home.latest_issue_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_issue'|translate}}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span>
                                    <a class="jounal-volume-link"
                                        [routerLink]="[ '/journal/',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue,eachJournal.latest_article]"
                                        [attr.aria-label]="('site_home.latest_article_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_article'|translate}}
                                    </a>
                                </span>
                            </div>
                        </div>
                        <div class="rvh-journal-socialmedia-icons">
                            <a *ngFor="let media of eachJournal.social_media_links" class="card-sm-icon "
                                [routerLink]="['{{media.value}}']" role="link" [attr.aria-label]="media.label">
                                <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                            </a>
                        </div>
                        <div class="rvh-journal-btn">
                            <a [routerLink]="[ '/journal/',eachJournal.id]"
                                [attr.aria-label]="'go to'+eachJournal.journal_display_name">{{'journal_home.go_to_journal'
                                |
                                translate}}</a>
                        </div>
                    </div>

                </div>
                <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end mt-4" data-aos="fade-right"
                    *ngIf="journalConferenceData && journalConferenceData.length!==0">
                    <a [routerLink]="['/proceedings']" tabindex="0" role="link"
                        aria-label="View all conference proceedings" class="">
                        {{'book_home.view_all' | translate}}
                        <span class="badge rounded-pill p-1 bg-primary">
                            <fa-icon aria-hidden="true" icon="arrow-right"></fa-icon>
                        </span>
                    </a>
                </p>
                <div class="section-title" data-aos="fade-up"
                    *ngIf="journalRetiredData && journalRetiredData.length!==0">
                    <h2 tabindex="0" class="primary-color">{{'app_header.proceedings'| translate}}
                        ({{'proceedings.retiredconference' | translate}}) </h2>
                    <p tabindex="0" class="rvh-sub-heading">{{'app_header.conference_sub_heading'|translate}}</p>
                </div>
                <div class="col-md-4" *ngFor="let eachJournal of journalRetiredData">
                    <div class="rvh-journal-card">
                        <img *ngIf="eachJournal.journal_cover_image" class="rvh-journal-cover-img" tabindex="0"
                            src="{{imageUrl+eachJournal.journal_cover_image}}"
                            [alt]="eachJournal.journal_cover_alt_text">
                        <img *ngIf="!eachJournal.journal_cover_image" class="rvh-journal-cover-img" tabindex="0"
                            src="{{defaultJournalCoverImage}}" [alt]="'site_home.default_journal_image'|translate">
                        <div class="rvh-journal-description-bk"></div>
                        <div class="rvh-journal-logo">
                            <img *ngIf="eachJournal.journal_logo" tabindex="0"
                                src="{{imageUrl+eachJournal.journal_logo}}" [alt]="eachJournal.journal_logo_alt_text">
                            <img *ngIf="!eachJournal.journal_logo" tabindex="0" src="{{defaultJournalLogo}}"
                                [alt]="'common.default_journal_logo'|translate">
                        </div>
                        <div class="rvh-journal-description" tabindex="0">
                            <div class="rvh-jnl-name" [attr.aria-label]="eachJournal.journal_display_name"
                                [innerHTML]="eachJournal.journal_display_name"></div>
                        </div>
                        <div class="rvh-journal-info pt-4">
                            <div>
                                <span>
                                    <a class="jounal-volume-link" [routerLink]="['/journal/',eachJournal.id,'volumes']"
                                        [attr.aria-label]="('site_home.latest_volume_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_volume'|translate}}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span>
                                    <a class="jounal-volume-link"
                                        [routerLink]="['/journal/',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue]"
                                        [attr.aria-label]="('site_home.latest_issue_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_issue'|translate}}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <span>
                                    <a class="jounal-volume-link"
                                        [routerLink]="[ '/journal/',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue,eachJournal.latest_article]"
                                        [attr.aria-label]="('site_home.latest_article_of'|translate)+eachJournal.journal_display_name">
                                        {{'site_home.latest_article'|translate}}
                                    </a>
                                </span>
                            </div>
                        </div>
                        <div class="rvh-journal-socialmedia-icons">
                            <a *ngFor="let media of eachJournal.social_media_links" class="card-sm-icon "
                                [routerLink]="['{{media.value}}']" role="link" [attr.aria-label]="media.label">
                                <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                            </a>
                        </div>
                        <div class="rvh-journal-btn">
                            <a [routerLink]="[ '/journal/',eachJournal.id]"
                                [attr.aria-label]="'go to'+eachJournal.journal_display_name">{{'journal_home.go_to_journal'
                                |
                                translate}}</a>
                        </div>
                    </div>

                </div>
                <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end mt-4" data-aos="fade-right"
                    *ngIf=" journalRetiredData && journalRetiredData.length!==0">
                    <a [routerLink]="['/proceedings']" tabindex="0" role="link"
                        aria-label="View all conference proceedings" class="">
                        {{'book_home.view_all' | translate}}
                        <span class="badge rounded-pill p-1 bg-primary">
                            <fa-icon aria-hidden="true" icon="arrow-right"></fa-icon>
                        </span>
                    </a>
                </p>

            </div>
            <div class="row d-flex align-items-stretch d-none">
                <div *ngFor="let eachJournal of journalData" class="col-lg-4 col-md-6 col-sm-1 z-index box-height mt-4"
                    data-aos="fade-up" data-aos-delay="100">
                    <div class="rvh-home-journals">
                        <div class="back-card text-color-blue">
                            <div class="ball">
                                <div class="ball-center">
                                </div>
                            </div>
                            <h1 tabindex="0" class="md-display-3 fw-bold back-card-text">{{'journal_home.journal' |
                                translate}}</h1>
                        </div>

                        <div class="position-relative card card-blue card-blue">
                            <div class="row">
                                <div class="col-2">
                                    <div class="position-absolute logo-btn fw-bold md-title">
                                        <img class="journal-logo" src="{{eachJournal.journal_logo}}"
                                            [alt]="eachJournal.journal_logo_alt_text">
                                    </div>
                                </div>

                                <div class="col-10">
                                    <div class=" text-white bg-primary">
                                        <div class="card-body card-blue-body width-card">
                                            <p class="fw-bold m-0">{{eachJournal.journal_title}}</p>
                                            <p class="m-0">{{eachJournal.journal_display}}</p>
                                            <div class="row">
                                                <div class="col border-right p-2">
                                                    <p class="m-0 font-light">
                                                        {{'site_home.latest_volume'|translate}}
                                                        {{eachJournal.latest_volume}}</p>
                                                    <p class="m-0 font-light">
                                                        {{'site_home.latest_issue'|translate}}
                                                        {{eachJournal.latest_issue}}</p>
                                                    <p class="m-0 font-light">
                                                        {{'site_home.latest_article'|translate}}
                                                        {{eachJournal.latest_article}}</p>
                                                    <button class="go-btn mt-2 rounded-pill font-light"
                                                        [routerLink]="[ '/journal/',eachJournal.journal_display]">
                                                        {{'journal.go_to_journals'|translate}}
                                                    </button>
                                                </div>
                                                <div class="col">
                                                    <div class="dot">
                                                        <div class="three-quater">
                                                            <div>
                                                                <div class="fa-list">
                                                                    <fa-icon aria-hidden="true" icon="list"></fa-icon>
                                                                </div>
                                                                <div class="align-icon">
                                                                    <span
                                                                        class="text-align-center">{{eachJournal.total_article_count}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <a *ngFor="let media of eachJournal.social_media_links"
                                                            class="card-sm-icon " routerLink="['{{media.value}}']"
                                                            role="link" [attr.aria-label]="media.label">
                                                            <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ball2 ">
                                <div class="ball2-center  d-flex align-items-center">
                                    <fa-icon aria-hidden="true" icon="right-long"
                                        class="text-color-blue p-2 position-relative"></fa-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <section id="books" class="books"  [attr.aria-label]="'book section'" *ngIf="book&&book.length!==0">
        <div class="container-fluid">
            <div class="section-title" data-aos="fade-up">
                <h2 tabindex="0">{{'app_header.books' | translate}}</h2>
                <p class="rvh-sub-heading" tabindex="0">{{'site_home.book_subheading'|translate}}</p>
            </div>

            <img class="grid-img rvh-grid-1 img-fluid position-absolute ml-1" src="assets/images/Repeat Grid 4.webp"
                alt="">

            <div class="row books-card">
                <div class="col-md-2 mt-4 firststcard cst-new-release card_width" data-aos="fade-up" data-aos-delay="50"
                    *ngFor="let data of book;let i = index">
                    <div class="book-hover ">
                        <div class="card shadow rvhws-book-card book-hover">
                            <div class=" ">
                                <div class="common-flex-space-between">
                                    <div class="text-align-start"><span class="badge bg-warning no-radius "
                                            tabindex="0">
                                            #{{i+1}}</span></div>
                                    <div tabindex="0" *ngIf="data.wishlist_flag==='true'"
                                        [attr.aria-label]="('site_home.bookmark_remove_aria_label'|translate)+ data.book_title"
                                        class="" (click)="setBookmarkStatus(i,bookmark[i],data.id)"
                                        (keyup.enter)="setBookmarkStatus(i,bookmark[i],data.id)"
                                        (keyup.space)="setBookmarkStatus(i,bookmark[i],data.id)">
                                        <!-- <fa-icon
                                            [ngClass]="{'text-color-blue': !bookmark[i], 'text-color-red': bookmark[i] }"
                                            class="pr-2"
                                            [icon]="bookmark[i] ? 'bookmark' : ['far', 'bookmark']"></fa-icon> -->
                                    </div>
                                    <div tabindex="0"
                                        [attr.aria-label]="('site_home.bookmark_add_aria_label'|translate)+ data.book_title"
                                        class="" (click)="setBookmarkStatus(i,data.wishlist_flag,data.id)"
                                        (keyup.enter)="setBookmarkStatus(i,data.wishlist_flag,data.id)"
                                        (keyup.space)="setBookmarkStatus(i,data.wishlist_flag,data.id)">
                                        <fa-icon class="text-color-blue pr-2" aria-hidden="true"
                                            [icon]="data.wishlist_flag ? 'bookmark' : ['far', 'bookmark']"></fa-icon>

                                    </div>
                                </div>
                                <div class="align-content-center pt-2 book-container rvhws-book-container">
                                    <div class="body book-body">
                                        <div class="book">
                                            <div class="first-half" *ngIf="data.book_cover_image">
                                                <img tabindex="0"
                                                    src="{{cover_image_url}}{{data.book_id}}/{{data.book_cover_image}}"
                                                    [alt]="data.book_alt_text">
                                            </div>
                                            <div class="first-half"
                                                *ngIf="!data.book_cover_image ||data.book_cover_image===null">
                                                <img tabindex="0" src="{{default_cover_image}}"
                                                    [alt]="'site_home.default_book_image'|translate">
                                            </div>
                                            <div class="middle-page3"></div>
                                            <div class="back-cover"></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="card-body text-color-black-home">

                                <p class="font-light fw-bold line-clamp" title="{{data.book_title}}"
                                    (click)="showBookChapterListing(data.book_id)"
                                    (keyup.enter)="showBookChapterListing(data.book_id)"
                                    (keyup.space)="showBookChapterListing(data.book_id)" tabindex="0"> {{data.book_title
                                    }}</p>

                                <p class="font-small fw-bold ">
                                    {{'book_home.editors' | translate}}:

                                    <span class="text-danger line-clamp-2" tabindex="0"
                                        [attr.aria-label]="'editors are'" title="{{getAuthorNames(data.book_authors)}}">
                                        <span *ngFor="let names of data.book_authors" class="text-danger"
                                            tabindex="0">{{names.givenNames}}
                                            {{names.surname}}
                                        </span>
                                    </span>


                                </p>
                                <div class="d-flex">

                                    <div class="star-div pt-1" tabindex="0"
                                        [attr.aria-label]="('site_home.book_rating_aria_label' | translate) +data.rating_count">

                                        <span class="text-warning font-light" *ngFor="let star of [1, 2, 3, 4, 5]"
                                            title="{{data.rating_count}}">

                                            <fa-icon [icon]="getStarIcon(data.rating_count, star)"
                                                aria-hidden="true"></fa-icon>
                                        </span>


                                    </div>
                                    <span class="font-light text-align-center pt-2 pl-2 count-span" tabindex="0"
                                        [attr.aria-label]="('site_home.comment_count_aria_label'|translate)+ data.comment_count"
                                        title="{{data.comment_count}}">({{data.comment_count}})</span>
                                </div>
                                <div class="footer-content-div pt-1">
                                    <span class="font-light text-light-blue fw-bold"
                                        title="${{data.book_discount_price}}" tabindex="0"
                                        [attr.aria-label]="('site_home.discount_price_aria_label'|translate)+ data.book_discount_price">
                                        {{data.book_discount_price}}</span>
                                    <span class="font-light pl-2" title="${{data.book_price}}" tabindex="0"
                                        [attr.aria-label]="('site_home.actual_price_aria_label'|translate)+ data.book_price">
                                        <del>{{data.book_price}}</del>
                                    </span>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>


            </div>
            <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end mt-4" data-aos="fade-right">
                <a [routerLink]="'/books'" role="link" [attr.aria-label]="'site_home.view_all_books'|translate"
                    class="">
                    {{'book_home.view_all' | translate}}
                    <span class="badge rounded-pill p-1 bg-primary">
                        <fa-icon aria-hidden="true" icon="arrow-right"></fa-icon>
                    </span>
                </a>
            </p>
        </div>
    </section>
    <section id="faq" class="faq"  *ngIf="faqData.length!==0" >
        <app-faq-section  [journalid]="journalID"></app-faq-section>

    </section>
    <!-- <app-faq-section  ></app-faq-section> -->
    <!-- <section id="faq" class="faq " *ngIf="faqData&&faqData.length>0">
        <div class="container-fluid">
            <div class="section-title" data-aos="fade-up">
                <h2>{{'journal_home.frequently_asked_questions' | translate}}</h2>
                <p class="rvh-sub-heading">{{'site_home.faq_sub_heading'|translate}}</p>
            </div>

            <div *ngFor="let questions of faqData" class="row faq-item d-flex align-items-stretch" data-aos="fade-up"
                data-aos-delay="100">
                <div class="col-lg-5">
                    <i class="ri-question-line"></i>
                    <p class="p-2" [innerHTML]="questions.faqQuestion"></p>
                </div>
                <div class="col-lg-7">
                    <p [innerHTML]="questions.faqAnswer">
                    </p>
                </div>
            </div>
        </div>
    </section> -->
</main>